import { Box, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  paddingY: '1.25',
  paddingX: '5.5',
  borderWidth: '2px',
  variant: ActionButtonVariants.OUTLINE,
  fullWidth: false,
  fontSize: 'sm',
  lineHeight: 'sm',
  letterSpacing: '0.5px',
});

export const StyledWrapper = Box.withConfig({
  alignItems: 'center',
});
